export default {
    bindings: {
        content: '<'
    },
    controller: 'optionsController',
    template: require('../views/options.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/checkout/components/options.component.js